import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

import unformat from 'accounting-js/lib/unformat.js';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { Property } from 'app/modules/projects/projects.types';
import { PropertyTenantsService } from '../../tenants.service';
import { PropertyUnit } from 'app/modules/projects/details/tenants/tenants.types';
import { AccountService } from '@core/services';
import { AccountSubdomainEnum } from '@core/enums';

@Component({
  selector: 'property-tenants-add-unit',
  templateUrl: './add-unit.component.html',
  styleUrls: ['./add-unit.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PropertyTenantsAddUnitComponent extends OnDestroyMixin implements OnInit {
  propertyUnitForm: UntypedFormGroup;
  property: Property;
  isLoading: boolean;
  isPostal: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly matDialogRef: MatDialogRef<PropertyTenantsAddUnitComponent>,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly propertyTenantsService: PropertyTenantsService,
    private readonly accountService: AccountService,
  ) {
    super();
    let account = this.accountService.getCurrentAccount();
    this.isPostal = account?.subdomain.includes(AccountSubdomainEnum.POSTAL);
  }

  ngOnInit(): void {
    this.buildForm();
  }

  private buildForm(): void {
    this.propertyUnitForm = this.formBuilder.group({
      id: [''],
      unit_number: ['', [Validators.required]],
      unit_size: [''],
      floor: [''],
    });

    this.property = this.data.property;

    if (this.data.propertyUnit) this.propertyUnitForm.patchValue(this.data.propertyUnit);
  }

  public discard(data?: PropertyUnit): void {
    this.matDialogRef.close(data);
  }

  public save(): void {
    this.propertyUnitForm.disable();
    let propertyUnit = this.propertyUnitForm.value;
    propertyUnit.property_id = this.property.id;
    propertyUnit.unit_size = unformat(propertyUnit.unit_size);

    if (this.data.propertyUnit && this.data.propertyUnit.id) {
      this.propertyTenantsService
        .updatePropertyUnit(propertyUnit)
        .pipe(untilComponentDestroyed(this))
        .subscribe((result) => this.discard(result));
    } else {
      this.propertyTenantsService
        .createPropertyUnit(propertyUnit)
        .pipe(untilComponentDestroyed(this))
        .subscribe((result) => this.discard(result));
    }
  }

  // Function attached to debounce-click directive to flag the button's disable state.
  public isDebounceLoading(isLoading: boolean): boolean {
    return (this.isLoading = isLoading);
  }

  public get isSaveBtnDisabled(): boolean {
    return this.isLoading || this.propertyUnitForm.pristine || this.propertyUnitForm.invalid;
  }
}
